import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReceiptionBell"><Path d="M13.002 5V6.05398C17.5559 6.54994 21 10.4232 21 16V18H13.002V19H21V21H3V19H11.002V18H3V16C3 10.4216 6.44611 6.54773 11.002 6.05356V5H9.00195V3H15.002V5H13.002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBell;
